class PagePrivate {

	constructor() {

		this.lostPasswordLink = document.querySelector('.lost-password');
		if( !this.lostPasswordLink )
			return;
		this.returnToIdentification = document.querySelector('.return-to-identification');
		this.loginForm = document.querySelector('.login-form');
		this.lostPasswordForm = document.querySelector('.lost-password-form');
		this.bindEvents();

	}

	bindEvents() {
		this.returnToIdentification.addEventListener('click', () => {
			this.backToIdentification();
		});

		this.lostPasswordLink.addEventListener('click', () => {
			this.lostPassword();
		});
	}

	backToIdentification() {
		this.loginForm.classList.remove('d-none');
		this.lostPasswordForm.classList.add('d-none');
	}

	lostPassword() {
		this.loginForm.classList.add('d-none');
		this.lostPasswordForm.classList.remove('d-none');
	}


}